import React from "react";
import ServicesHero from "../Components/ServicesHero/ServicesHero";
import CardsSection from "../Components/CardsSection/CardsSection";

const OurServices = () => {
  return (
    <>
      <ServicesHero />
      <CardsSection />
    </>
  );
};

export default OurServices;
